var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3E3E64;stroke:#1D1D1B;stroke-miterlimit:10;}\n\t.st1{fill:#3E3E64;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.6,15.4c0-0.1,0-0.2,0-0.3c1.1-1.9,1.6-3.9,1.3-6c-0.4-3.3-2-5.9-4.9-7.6C13.5,0.4,11.7,0,9.8,0 C6.9,0.1,4.4,1.2,2.5,3.4C1.2,4.9,0.4,6.7,0.1,8.6C0.1,8.9,0,9.1,0,9.4v1.2c0.1,0.4,0.1,0.7,0.2,1.1C0.6,14.3,2,16.5,4.1,18 c1.5,1.1,3.3,1.8,5.2,1.9c0,0,0.1,0,0.1,0h1.2c0.4-0.1,0.7-0.1,1.1-0.2c1.2-0.2,2.3-0.6,3.3-1.2c0.1-0.1,0.3-0.1,0.4,0 c1.3,0.4,2.5,0.9,3.8,1.3c0.1,0,0.1,0.1,0.2,0.1h0.3c0.4-0.2,0.4-0.4,0.3-0.8C19.5,17.9,19,16.6,18.6,15.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFilled);
export default __webpack_public_path__ + "static/media/comment-filled.fdb0da9fb4c0c7b328b43ae5435cf83f.svg";
export { ForwardRef as ReactComponent };